import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { environment } from '../../environments/environment';

@Directive({
  selector: 'img[appImgFallback]'
})
export class ImgFallbackDirective {

  private triedFallback = false;

  @HostListener('error')
  onError() {
    if (this.triedFallback) return;
    this.triedFallback = true;

    const el = this.el.nativeElement as HTMLImageElement;
    const src = el.src || '';

    // If current src uses admin_upload path, try assets_base (root)
    if (src.includes('/admin-uploads/docs/')) {
      el.src = src.replace('/admin-uploads/docs/', '/');
    }
    // If current src uses assets_base (root), try admin_upload path
    else if (src.includes('assets.foursightonline.com/') && !src.includes('/admin-uploads/') && !src.includes('/app/')) {
      const base = 'https://assets.foursightonline.com/';
      const assetId = src.split(base).pop();
      if (assetId) {
        el.src = environment.admin_upload + assetId;
      }
    }
  }

  constructor(private el: ElementRef) {}
}
